<template>
  <div class="layout login-view">
    <div class="layout-top">
      <el-row>
        <el-col :span="18" class="layout-top-left">
          <img :src="logoUrl" class="layout-logo" alt="" /><span class="ly-version">{{version}}</span>
        </el-col>
        <el-col :span="6" class="layout-top-right">
        </el-col>
      </el-row>
    </div>
    <div class="login-body">
      <div class="container">
        <el-tabs value="login">
          <el-tab-pane label="登录" name="login">
            <el-form ref="login_form" :model="loginInfo" :rules="loginRules" label-width="0" class="login-from">
              <el-form-item prop="mobile">
                <el-input v-model="loginInfo.mobile" @keyup.enter.native="login" placeholder="请输入手机号码" :maxlength="11">
                  <i slot="prefix" class="iconfont icon-mobile"></i>
                </el-input>
              </el-form-item>
              <el-form-item prop="pwd">
                <el-input v-model="loginInfo.pwd" @keyup.enter.native="login" placeholder="请输入密码" :maxlength="30" type="password">
                  <i slot="prefix" class="iconfont icon-lock"></i>
                </el-input>
              </el-form-item>
            </el-form>
            <div>
              <el-button type="primary" @click="login" :loading="loading">登&nbsp;录</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="注册" name="register">
            <el-form ref="register_form" :model="registerInfo" status-icon :rules="registerRules" label-width="85px" label-position="left">
              <el-form-item label="手机号码：" prop="mobile">
                <el-input v-model="registerInfo.mobile" placeholder="请输入手机号码" auto-complete="off" :maxlength="11">
                  <i slot="prefix" class="iconfont icon-mobile"></i>
                </el-input>
              </el-form-item>
              <el-form-item label="昵称：" prop="nick">
                <el-input v-model="registerInfo.nick" placeholder="请输入昵称" auto-complete="off" :maxlength="10">
                  <i slot="prefix" class="iconfont icon-user"></i>
                </el-input>
              </el-form-item>
              <el-form-item label="密码：" prop="pwd">
                <el-input v-model="registerInfo.pwd" @keyup.enter.native="register" placeholder="请输入密码" auto-complete="off" :maxlength="30" type="password">
                  <i slot="prefix" class="iconfont icon-lock"></i>
                </el-input>
              </el-form-item>
              <el-form-item label="确认密码：" prop="repeat">
                <el-input v-model="registerInfo.repeat" @keyup.enter.native="register" placeholder="请重复输入密码" auto-complete="off" :maxlength="30" type="password">
                  <i slot="prefix" class="iconfont icon-lock"></i>
                </el-input>
              </el-form-item>
            </el-form>
            <div>
                <el-button type="primary" :loading="loading" @click="register">注&nbsp;册</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>

      </div>
    </div>
    <div class="login-footer tc">
      <p class="footer-1">Copyright © {{year}} 上海爱听教育科技有限公司. All Rights Reserved. ICP备案证书号：<a href="//www.beian.miit.gov.cn/" target="_blank">沪ICP备18025331号</a></p>
    </div>
  </div>
</template>

<script>
import { isMobile } from 'assets/js/functions'
let logoUrl = require('assets/image/logo.jpg')
export default {
  name: 'Login',
  data () {
    let checkMobile = (rule, value, callback) => {
      if (value) {
        if (isMobile(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的手机号码'))
        }
      } else {
        callback(new Error('请输入您的手机号码'))
      }
    }
    let checkPassword = (rule, value, callback) => {
      if (!value || value.length < 6) {
        callback(new Error('密码最少6位'))
      } else if (this.registerInfo.repeat) {
        this.$refs.register_form.validateField('repeat')
      }
      callback()
    }
    let checkPassword2 = (rule, value, callback) => {
      if (value) {
        if (value !== this.registerInfo.pwd) {
          callback(new Error('两次输入密码不一致'))
          return
        }
      }
      callback()
    }
    return {
      logoUrl,
      year: new Date().getFullYear(),
      version: window.appConfig.version,
      loading: false,
      loginInfo: {
        mobile: '',
        pwd: ''
      },
      loginRules: {
        mobile: [
          { required: true, message: '请输入您的手机号码', trigger: 'change' },
          { validator: checkMobile, trigger: 'blur' }
        ],
        pwd: [{ required: true, message: '请输入您的密码', trigger: 'change' }]
      },
      registerInfo: {
        mobile: '',
        nick: '',
        pwd: '',
        repeat: ''
      },
      registerRules: {
        mobile: [
          { required: true, message: '请输入您的手机号码', trigger: 'change' },
          { validator: checkMobile, trigger: 'blur' }
        ],
        nick: [{ required: true, message: '请输入昵称', trigger: 'change' }],
        pwd: [
          { required: true, message: '请输入密码', trigger: 'change' },
          { validator: checkPassword, trigger: 'blur' }
        ],
        repeat: [
          { required: true, message: '请重复输入密码', trigger: 'change' },
          { validator: checkPassword2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    login () {
      // 防止重复提交登录信息
      if (this.loading) {
        return false
      }
      this.$refs.login_form.validate((valid) => {
        if (valid) {
          this.loading = true
          // 调用api登录接口
          this.$store.dispatch('login', this.loginInfo)
            .then(response => {
              this.loading = false
              if (response && response.token) {
                this.$message.success('登录成功')
                this.$router.push({ path: '/user/center' })
              } else {
                this.$message.error('您输入的手机号或密码错误，请重新输入')
              }
            })
            .catch((error) => {
              this.loading = false
              let msg = (error && error.msg) || '登录失败'
              this.$message.error(msg)
            })
        } else {
          return false
        }
      })
    },
    register () {
      // 防止重复提交注册信息
      if (this.loading) {
        return false
      }
      this.$refs.register_form.validate((valid) => {
        if (valid) {
          this.loading = true
          // 调用api注册接口
          this.$store.dispatch('register', this.registerInfo)
            .then(response => {
              this.$message.success('注册成功')
              // 调用api登录接口
              this.$store.dispatch('login', this.registerInfo)
                .then(response => {
                  this.loading = false
                  this.$router.push({ path: '/user/center' })
                })
            })
            .catch((error) => {
              this.loading = false
              let msg = (error && error.msg) || '注册失败'
              this.$message.error(msg)
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss">
.login-view {
  display: flex;
  flex-direction: column;
  .layout-top {
    // background: #83dd69;
  }
  .login-body {
    flex: 1;
    // background: #ccc;
    background: url('/static/img/login-bg.jpg') no-repeat;
    background-size: cover;
    position: relative;
    .container {
      position: absolute;
      background: #FFF;
      border-radius: 8px;
      padding: 20px 40px 40px;
      width: 260px;
      top: 50%;
      right: 15%;
      transform: translate(0, -50%);
      .el-tabs__nav {
        width: 100%;
      }
      .el-tabs__item {
        width: 50%;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
      }
      .el-tabs__content {
        margin-top: 30px;
      }
      .el-form-item {
        margin-bottom: 30px;
      }
      .el-form-item__label {
        padding: 0;
      }
      .el-button {
        width: 100%;
      }
      .el-input__prefix {
        width: 25px;
        text-align: center;
      }
    }
  }
  .login-from {
    // background: #FFF;
    // padding: 0 30px;
  }
  .login-footer {
    background: #FFF;
    font-size: 12px;
    padding: 20px;
    line-height: 24px;
    .footer-1 {
      color: #212121;
    }
    .footer-2 {
      color: #808080;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue